export enum NotificationsCases {
  ON_NEW = "ON_NEW",
  ON_ASSIGN = "ON_ASSIGN",
  ON_AUTO_REMINDER = "ON_AUTO_REMINDER",
}
